const onSubmitHandler = (event) => {
  event.preventDefault();

  const form = event.target;
  const wrapper = form.querySelector('.js-custom-form__contact-checkbox-block');
  const consentCheckbox = wrapper.querySelectorAll('[type="checkbox"]');

  const countrySelect = form.querySelector('.js-custom-form [type="country"]');
  const countryCode = countrySelect.value;
  const explicitValue = '1';
  const wrapperData = wrapper.dataset;
  const gdprCountries = wrapperData.gdprCountries.split(' ');
  const nonGdprMoreCautiousCountries = wrapperData.nonGdprMoreCautiousCountries.split(' ');
  const {
    gdprType,
    nonGdprMoreCautiousType,
    nonGdprLessCautiousType,
    programLanguage,
    consentRadiobuttonErrorMessage,
  } = wrapperData;

  let consentType;
  if (countryCode === 'BR' && programLanguage === 'pt') {
    consentType = '2';
  } else if (gdprCountries.includes(countryCode)) {
    consentType = gdprType;
  } else if (nonGdprMoreCautiousCountries.includes(countryCode)) {
    consentType = nonGdprMoreCautiousType;
  } else {
    consentType = nonGdprLessCautiousType;
  }

  if (consentType === explicitValue
    && !(consentCheckbox[0].checked || consentCheckbox[1].checked)) {
    const errorExists = form.querySelector('.js-consent-checkbox-error');

    if (!errorExists) {
      const div = document.createElement('div');
      div.classList.add('form__validation-error-message-checkbox');
      div.classList.add('js-consent-checkbox-error');
      div.innerHTML = consentRadiobuttonErrorMessage;

      const input = wrapper.getElementsByClassName('input-inline')[0];
      input.parentNode.prepend(div);
    }
  }
};

const selectOnlyOne = (event) => {
  const { checkboxes } = event.currentTarget;

  checkboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });

  const checkbox = event.target;
  checkbox.checked = true;

  const errorExists = document.querySelector('.js-consent-checkbox-error');

  if (errorExists) {
    errorExists.remove();
  }
};

const consentRadiobutton = () => {
  const forms = document.querySelectorAll('.js-custom-form');

  forms.forEach((form) => {
    form.addEventListener('submit', onSubmitHandler);
  });

  const checkboxes = document.querySelectorAll('.form-check-input');

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('click', selectOnlyOne);
    checkbox.checkboxes = checkboxes;
  });
};

export default consentRadiobutton;
